export default {
	"plan": {
		"pickUpPeriod": "提货段",
		"deliveryPeriod": "送货段",
		"notPickup": "不提货",
		"noDelivery": "不送货",
		"saveTransportOrderSort": "运单顺序已保存",
		"transfer": "中转",
		"revokeTransfer": "撤销中转",
		"notNeedPickUp": "该运单不需要提货",
		"canNotPickUp": "该运单能提货",
		"notNeedDelivery": "此单不需要送货",
		"canNotDelivery": "此单不能送货"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/plan/plan.js